import api from '../interceptors/interceptor';
import { API_ROUTES } from '../constants/apiRoutes';
import axios from 'axios';

class PromptLabRepository {
  private static instance: PromptLabRepository;

  private constructor() {}

  public static getInstance(): PromptLabRepository {
    if (!PromptLabRepository.instance) {
      PromptLabRepository.instance = new PromptLabRepository();
    }
    return PromptLabRepository.instance;
  }

  async getUsageTypes(): Promise<any[]> {
    try {
      const response = await api.get(API_ROUTES.USAGE_TYPES);
      return response.data || [];
    } catch (error: any) {
      console.error('Error fetching usage types:', error);
      console.error('Error response:', error.response);
      console.error('Error config:', error.config);
      return [];
    }
  }

  async getPromptVariables(): Promise<any> {
    try {
      // Bypass the interceptor by using axios directly with the specific bearer token
      const response = await axios.get(`${window.env.REACT_APP_BASE_URL}${API_ROUTES.PROMPT_VARIABLES}`, {
        headers: {
          Authorization: 'Bearer LPkbhCFNEE5efl8YEx6MUp71QU10NnIH'
        }
      });
      return response.data || { prompt_variables: [] };
    } catch (error: any) {
      console.error('Error fetching prompt variables:', error);
      console.error('Error response:', error.response);
      console.error('Error config:', error.config);
      return { prompt_variables: [] };
    }
  }

  async getPrompts(): Promise<any[]> {
    try {
      const response = await api.get(API_ROUTES.PROMPTS);
      return response.data || [];
    } catch (error) {
      console.error('Error fetching prompts:', error);
      return [];
    }
  }

  async savePrompt(payload: any): Promise<any> {
    try {
      const response = await api.post(API_ROUTES.PROMPTS, payload);
      return response.data;
    } catch (error) {
      console.error('Error saving prompt:', error);
      throw error;
    }
  }

  async updatePrompt(promptId: string, payload: any): Promise<any> {
    try {
      const response = await api.put(`${API_ROUTES.PROMPTS}/${promptId}`, payload);
      return response.data;
    } catch (error) {
      console.error('Error updating prompt:', error);
      throw error;
    }
  }

  async setPromptAsDefault(promptId: string): Promise<any> {
    try {
      // POST to set a version as default (creates a new record)
      const response = await api.post(`${API_ROUTES.PROMPTS}/${promptId}/set-default`);
      return response.data;
    } catch (error) {
      console.error('Error setting prompt as default:', error);
      throw error;
    }
  }

  async createUsageType(payload: { name: string; description: string; is_active: boolean }): Promise<any> {
    try {
      const response = await api.post(API_ROUTES.USAGE_TYPES, payload);
      return response.data;
    } catch (error) {
      console.error('Error creating usage type:', error);
      throw error;
    }
  }
}

export const promptLabRepository = PromptLabRepository.getInstance();
